"use client"

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

export const laptopContents: ReactNode = (
  <>
    <section className="mb-8">
      <h2 className="text-2xl font-bold mb-4 leading-tight">Sewa Laptop Terdekat Harga Jujur, Spek Ngebut, Tanpa Ribet</h2>
      <p className="mb-4 text-base leading-relaxed">
        Nggak perlu cari jauh-jauh. <strong>Sewa laptop terdekat</strong> dari titik lokasi kamu, kirim cepat, harga fleksibel, dan spek tinggal pilih. Mau untuk harian, mingguan, sampai project tahunan semua bisa disesuaikan. Kamu fokus
        kerja, urusan teknis biar kami yang urus.
      </p>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3">Kenapa Harus Sewa Laptop Terdekat?</h2>
      <ul className="space-y-4">
        <li className="bg-white p-5 rounded-xl shadow border border-gray-100">
          <h3 className="font-bold text-lg mb-1">Lebih Cepat & Hemat Waktu</h3>
          <p className="text-sm">Titik distribusi tersebar. Tim lokal kami siap antar dalam hitungan jam, bukan hari. Cari <strong>sewa laptop terdekat</strong>? Kami jawab paling cepat.</p>
        </li>
        <li className="bg-white p-5 rounded-xl shadow border border-gray-100">
          <h3 className="font-bold text-lg mb-1">Harga Sewa Laptop Bisa Disesuaikan</h3>
          <p className="text-sm">Mulai dari laptop basic buat Zoom meeting, sampai laptop gaming dengan RTX, kami punya semua. <strong>Harga sewa laptop</strong>? Bisa nego. Tergantung spek, brand, dan durasi.</p>
        </li>
        <li className="bg-white p-5 rounded-xl shadow border border-gray-100">
          <h3 className="font-bold text-lg mb-1">Brand Lengkap, Spek Sesuai</h3>
          <p className="text-sm">ASUS, Acer, HP, Lenovo, MacBook spek bisa custom, RAM 8GB sampai 64GB, SSD kencang, layar touchscreen, dan koneksi stabil. Cukup bilang keperluannya, kami pilihkan yang paling pas.</p>
        </li>
      </ul>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3">Gratis Ongkir & Setup Langsung di Lokasi</h2>
      <p className="mb-4 text-sm">
        Lokasi kamu Jabodetabek? Nikmati <strong>sewa laptop terdekat</strong> dengan gratis ongkir dan tim teknisi siap bantu setup sampai laptop siap dipakai. Bahkan bisa langsung install software khusus kalau dibutuhkan.
      </p>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3">Durasi Fleksibel, Bisa Harian atau Bulanan</h2>
      <p className="mb-4 text-sm">Kebutuhan jangka pendek? Sewa harian. Buat operasional kantor? Sewa bulanan. Semua fleksibel. Bahkan kalau mendadak butuh tambah unit, tinggal chat langsung kami kirim.</p>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3">Bukan Sekadar Sewa Ini Solusi Total</h2>
      <p className="mb-4 text-sm">
        Setiap laptop diservis rutin, full support selama masa sewa, dan ganti unit langsung bila ada kendala. Kamu cukup bilang kebutuhanmu. Kami siapkan armada terbaik untuk <strong>layanan sewa laptop terdekat</strong> yang benar-benar
        memudahkan.
      </p>
    </section>

    <CTA
      title="Siap Kerja Editing & Olah Data Dimana² Bosku?"
      description="🚚 Butuh sewa laptop terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Laptop Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20laptop.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Laptop"
    />

  </>
);
